<div class="flex items-center gap-2 w-full">
  <p-select
    class="flex-1 min-w-0"
    styleClass="w-full"
    [inputId]="inputId"
    [options]="options"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    filterBy="label,hint"
    [showClear]="true"
    [placeholder]="placeholder ?? ('animalMedical.veterinarianSelect.placeholder' | transloco)"
    [emptyMessage]="'animalMedical.veterinarianSelect.empty' | transloco"
    [emptyFilterMessage]="'animalMedical.veterinarianSelect.empty' | transloco"
    [ngModel]="value"
    (ngModelChange)="onSelect($event)"
    (onBlur)="markTouched()"
    [disabled]="disabled"
    [invalid]="invalid"
    appendTo="body"
  >
    <ng-template pTemplate="item" let-option>
      <div class="flex flex-col">
        <span>{{ option.label }}</span>
        @if (option.hint) {
          <small class="text-xs text-gray-500">{{ option.hint }}</small>
        }
      </div>
    </ng-template>
  </p-select>
  <p-button
    icon="pi pi-plus"
    [outlined]="true"
    [disabled]="disabled"
    [pTooltip]="'animalMedical.veterinarianSelect.create' | transloco"
    tooltipPosition="top"
    [ariaLabel]="'animalMedical.veterinarianSelect.create' | transloco"
    data-cy="veterinarian-create"
    (onClick)="openCreate()"
  />
</div>

<p-dialog
  [(visible)]="createVisible"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closeCreate()"
>
  <ng-template pTemplate="header">
    <h3>{{ 'animalMedical.veterinarianSelect.createHeader' | transloco }}</h3>
  </ng-template>
  <ng-template pTemplate="content">
    @if (createVisible) {
      <app-choose-contact
        [onlyCreateContact]="true"
        [presetVeterinary]="true"
        [newContact]="newContact"
        (newContactUpdated)="newContact = $event"
        (validationStatusChanged)="createValid = $event"
      />
    }
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-times"
      [text]="true"
      [label]="'modal.cancel' | transloco"
      (onClick)="closeCreate()"
    />
    <p-button
      icon="pi pi-save"
      [label]="'modal.save' | transloco"
      [disabled]="!createValid || saving"
      [loading]="saving"
      data-cy="veterinarian-create-save"
      (onClick)="saveCreate()"
    />
  </ng-template>
</p-dialog>
